import React from 'react';
import classnames from 'classnames';
import { BodyText, Eyebrow } from '@servicetitan/design-system';
import { CalculatedProgram } from 'src/api';
import * as Utils from '../../forms/application-information-forms-utils';

import styles from './plan-details.less';

interface IProps {
    plan: CalculatedProgram;
    isDisabled?: (plan: CalculatedProgram) => void;
}

export const PlanCard: React.FC<IProps> = ({ plan, isDisabled }) => {
    return (
        <React.Fragment>
            <BodyText size="small" className={styles.planDescription}>
                {plan.description}
            </BodyText>
            <hr />
            {plan.promotionalTerms > 0 ? (
                <React.Fragment>
                    <Eyebrow size="large" className={styles.planPromotion}>
                        {plan.promotionalTerms} Month Promo
                    </Eyebrow>
                    <div className={styles.rightItem}>
                        <BodyText size="small" bold>
                            Max Interest
                        </BodyText>
                        <BodyText size="medium" bold>
                            {plan.promotionalRate}%
                        </BodyText>
                    </div>
                    <div className={styles.leftItem}>
                        <BodyText size="small" bold>
                            Monthly Payment
                        </BodyText>
                        <BodyText size="medium" bold className={styles.planPromotion}>
                            {Utils.moneyFormatter.format(plan.promotionalMonthlyPayment)}
                        </BodyText>
                    </div>
                    <hr />
                </React.Fragment>
            ) : null}

            <Eyebrow size="large">Regular Payments</Eyebrow>
            <div className={styles.rightItem}>
                <BodyText size="small" bold>
                    Max Interest
                </BodyText>
                <BodyText size="medium" bold>
                    {plan.defaultRate}%
                </BodyText>
            </div>
            <div className={styles.leftItem}>
                <BodyText size="small" bold>
                    Monthly Payment
                </BodyText>
                <BodyText size="medium" bold>
                    {Utils.moneyFormatter.format(plan.defaultMonthlyPayment || 0)}
                </BodyText>
            </div>
            <div className={styles.rightItem}>
                <BodyText size="small" bold>
                    Min Loan Amt
                </BodyText>
                <BodyText
                    size="medium"
                    bold
                    className={classnames({ [styles.invalidLoan]: isDisabled && isDisabled(plan) })}
                >
                    {Utils.moneyFormatter.format(plan.minLoanAmount || 0)}
                </BodyText>
            </div>
            <div className={styles.leftItem}>
                <BodyText size="small" bold>
                    Terms
                </BodyText>
                <BodyText size="medium" bold>
                    {plan.defaultTerms}
                </BodyText>
            </div>
            <div className={styles.leftItem}>
                <BodyText size="small" bold>
                    Plan
                </BodyText>
                <BodyText size="medium" bold>
                    {plan.planNumber}
                </BodyText>
            </div>
        </React.Fragment>
    );
};
